import React, { Fragment } from 'react';
import { Row, Col } from 'react-bootstrap';
import autoBind from 'react-autobind';

//Connect
import { connect } from '@common/components/base.component';

//Context
import accessControlValidation from '@common/validators/accessControl.validator';
import { withGridContext } from './grid.factory';

//Parts
import GridColumnHeader from './grid.columnHeader';
import GridOrdering from './grid.ordering';
import GridActionColumn from './grid.actionColumn';
import GridRow from './grid.row';
import GridPagination from './grid.pagination';
import GridToolbar from './grid.toolbar';
import GridViewFilter from './grid.viewFilter';
import GridConsultaSQL from './grid.consultaSQL';
import GridButtonFooter from './grid.buttonFooter';
import Skeleton from '@common/components/skeleton/skeleton.component';

import ReportModal from '../../relatorioGerencial/emissao/components/emissaoRelatorioAssociado.modal';

class GridMain extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      wrapperBounds: [],
      showModal: false,
      componentUrl: null,
    };

    this.gridRefs = {
      wrapper: React.createRef(),
    };
    autoBind(this);
  }

  componentDidMount() {
    var wrapperGrid = $(this.gridRefs.wrapper.current);

    var top = wrapperGrid.offset().top;
    var left = wrapperGrid.offset().left;
    var height = wrapperGrid.height();
    var width = wrapperGrid.width();
    this.setState({ wrapperBounds: [left, top, left + width, top + height] });
  }

  getCenterGridMessage() {
    const { context, hasFilter } = this.props;

    if (hasFilter) {
      if (
        !context.isFetched ||
        (!context.columns.some((x) => x.isFiltered) &&
          context.data.dataList == 0 &&
          !this.props.options.applySearchOnLoad)
      )
        return 'É necessário definir pelo menos um filtro para executar uma busca.';
    }

    if (context.data.dataList == 0) return 'Nenhum registro encontrado.';
  }

  get isAllChecked() {
    const { context } = this.props;
    const { data } = context;
    return data.dataList.length > 0 && !data.dataList.some((x) => !x.isChecked);
  }

  onCheckAll(e) {
    const { checked } = e.target;
    const { context } = this.props;
    context.checkAll(checked);
  }

  checkDetailPermission(url) {
    if (Array.isArray(url)) return url.some((x) => accessControlValidation.checkPermissionByUrl(x));
    if (url) return accessControlValidation.checkPermissionByUrl(url);
    return true;
  }

  disableGrid() {
    const { context } = this.props;
    if (!this.isSkeletonLoaded) {
      let containerGrid = document.getElementById('ContainerGridMainId' + context.hash);
      if (containerGrid) {
        containerGrid.setAttribute('style', 'display:none');
      }
    }
  }

  disableSkeleton() {
    const { context } = this.props;
    let containerGrid = document.getElementById('ContainerGridMainId' + context.hash);
    if (containerGrid) containerGrid.setAttribute('style', 'display:block');

    let containerSkeleton = document.getElementById('ContainerSkeletonId' + context.hash);
    if (containerSkeleton) {
      containerSkeleton.setAttribute('style', 'display:none !important;');
    }
  }

  onReportModal(item) {
    const { context } = this.props;
    const { data } = context;
    const { dataList } = data;

    var selecaoItens = [];

    var selectedItens = dataList.filter((x) => x.isChecked);

    if (selectedItens.length == 0) {
      _alert.warning('Selecione pelo menos um item para a impressão!');
      return;
    }

    selectedItens.map((item) => {
      if (item != null && item.Id != null) {
        selecaoItens.push(item.Id);
      }
    });

    if (selecaoItens.length == 0) {
      _alert.warning('Não é possível imprimir, o ID não foi configurado. Entre em contato com a SMARAPD.');
      return;
    }

    this.setState({
      componentUrl: item,
      showModal: true,
      selecaoItens: selecaoItens,
    });
  }

  onCancelModal() {
    this.setState({ showModal: false });
  }

  render() {
    const {
      context,
      routerManager,
      hasPagination,
      hidBarPagination,
      hasFilter,
      hasOrdering,
      hasToolbar,
      hasScrollY,
      isView,
      disableNew
    } = this.props;

    const { wrapperBounds } = this.state;
    const { columns, toolbar, data, options, actions, detail, hash } = context;
    const { enableSkeleton, hideActionColumn } = options;
    const { dataList } = data;

    const hasActionColumn = actions?.length > 0 && !hideActionColumn;
    const centerGridMessage = this.getCenterGridMessage();
    const modulo = options?.webStorage?.split('.')[0];

    return (
      <Fragment>
        <ReportModal
          componentUrl={this.state.componentUrl}
          selecaoItens={this.state.selecaoItens}
          onCancel={() => {
            this.setState({ showModal: false });
          }}
          show={this.state.showModal}
          modulo={modulo}
        />

        <div id={'ContainerSkeletonId' + context.hash}>{enableSkeleton ? <Skeleton modelSkeleton={'Grid'} /> : ''}</div>
        <div id={'ContainerGridMainId' + context.hash}>
          {enableSkeleton ? (!context.isFetched ? this.disableGrid() : this.disableSkeleton()) : ''}
          <Row>
            <Col lg={12}>
              <Row>
                <Col lg={12}>
                  {toolbar.title != undefined && (
                    <h2 className="float-left func-name">
                      {toolbar.prefix || 'Busca de '} {toolbar.title}
                    </h2>
                  )}
                  {toolbar.header}
                </Col>
              </Row>
              {hasFilter && <GridViewFilter />}
              
              <GridConsultaSQL />
              
              <div className="gridContainer">
                <Row>
                  <Col lg={12}>
                    <div className="well">
                      {(hasOrdering || hasToolbar) && (
                        <Row>
                          <Col lg={7}>{hasOrdering && <GridOrdering />}</Col>
                          <Col lg={5}>
                            {hasToolbar && toolbar && (
                              <GridToolbar
                                onPrint={this.props.onPrint}
                                onReportModal={(item) => {
                                  this.onReportModal(item);
                                }}
                                disableNew={disableNew}
                                hasFilter={hasFilter}
                              />
                            )}
                          </Col>
                        </Row>
                      )}
                      <div className="container-all">
                        <div className={`container-grid container-full`}>
                          <div
                            ref={this.gridRefs.wrapper}
                            className={`${this.props.editHeight ? '' : 'wrapper-grid '} ${
                              hasScrollY && 'overflow-scrollY'
                            }`}
                            style={{
                              height: this.props.editHeight && 
                              this.props.height ? 
                              this.props.height : '',
                              overflow: 'auto',
                              minHeight: this.props.editHeight ? 
                              '1rem' : 
                              ''
                            }}
                          >
                            <table
                              className="table table-action-striped table-bordered table-hover table-grid"
                              style={{ position: 'relative', zIndex: '98' }}
                              data-grid={hash}
                            >
                              <thead>
                                <tr className="success" style={{ position: 'sticky', top: '0', zIndex: '999' }}>
                                  {detail && this.checkDetailPermission(detail.url) && (
                                    <th className="" style={{ width: '30px' }} />
                                  )}
                                  {options.onReorder && <th style={{ width: '30px' }} />}
                                  {!options.isNotCheckable && (
                                    <th
                                      className="checkbox-all table-action-checked"
                                      style={{
                                        textOverflow: 'clip',
                                        textAlign: 'center',
                                        position: 'sticky',
                                        top: '0',
                                        left: '0',
                                        zIndex: '9999',
                                        borderBottomWidth: '0px',
                                      }}
                                    >
                                      {!options.isNotAllCheckable && (
                                        <input
                                          type="checkbox"
                                          checked={this.isAllChecked || false}
                                          onChange={this.onCheckAll}
                                        />
                                      )}
                                    </th>
                                  )}

                                  {columns.map((column, i) => (
                                    <GridColumnHeader
                                      key={i}
                                      column={column}
                                      index={i}
                                      onOpenFilter={this.onOpenFilter}
                                      bounds={wrapperBounds}
                                      hasFilter={hasFilter}
                                    />
                                  ))}
                                  {hasActionColumn && (
                                    <th
                                      className="text-center"
                                      style={{
                                        width: '100px',
                                        position: 'sticky',
                                        right: '0',
                                        top: '0',
                                        zIndex: '999',
                                        borderBottomWidth: '0px',
                                      }}
                                    >
                                      <label>Ações</label>
                                    </th>
                                  )}
                                </tr>
                              </thead>
                              <tbody>
                                {dataList.map((item, i) => (
                                  <GridRow
                                    key={i}
                                    item={item}
                                    columns={columns}
                                    index={i}
                                    isView={isView}
                                    gridRefs={this.gridRefs}
                                  />
                                ))}
                              </tbody>
                            </table>
                            {centerGridMessage && (
                              <div
                                className={`${
                                  this.props.editHeight ? 
                                  '' : 
                                  'gridValidationAlert '
                                }`}
                                style={{ 
                                  height: this.props.editHeight && 
                                  this.props.height ? 
                                  this.props.height : '',
                                  minHeight: this.props.editHeight ? 
                                  '1rem' : '',
                                  textAlign: 'center'
                                }}
                              >
                                  {centerGridMessage}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <GridPagination hasPagination={hasPagination} hidBarPagination={hidBarPagination} />
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row>
            <GridButtonFooter routerManager={routerManager} />
          </Row>
        </div>
      </Fragment>
    );
  }
}

GridMain.defaultProps = {
  hasPagination: true,
  hidBarPagination: false,
  hasFilter: true,
  hasOrdering: true,
  hasToolbar: true,
  hasScrollY: false,
};

export default connect()(withGridContext(GridMain));
